import { ListOrdered } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsOrderedList } from 'store/actions/editorActions';
import CustomTooltip from '../../../CustomTooltip';

export default function OrderedListTool({ editorRef }) {
    const isOrderedList = useSelector((state) => state.editorReducers.isOrderedList);

    const dispatch = useDispatch();

    function handleOrderedList() {
        if (editorRef.current) {
            const quill = editorRef.current;
            const selection = quill.getSelection();
            const format = quill.getFormat();

            if (!selection) return;

            const blot = quill.getLeaf(selection.index)[0];

            if (blot && blot?.parent?.domNode?.closest('table')) {
                return;
            }

            if (format['list']) {
                quill.format('list', false);
                dispatch(setIsOrderedList(false));
            } else {
                quill.format('list', 'ordered');
                dispatch(setIsOrderedList(true));
            }

            quill.focus();
        }
    }

    return (
        <CustomTooltip title="Ordered List" placement="bottom">
            <button
                className={`!h-7 !w-7 !rounded grid place-items-center transition-all hover:brightness-95 ${
                    isOrderedList ? 'text-[#395BA9] bg-[#395BA910]' : 'text-[#1E293B] bg-white'
                }`}
                onClick={handleOrderedList}
            >
                <ListOrdered className="h-5 w-5" />
            </button>
        </CustomTooltip>
    );
}
